// Import Components
import CopyToClipboard from 'components/common/CopyToClipboard';
import TittleLink from 'components/common/TittleLink';
import AdminProviderPartnersInfo from './AdminProviderPartnersInfo';
// Import Constants
import { l, BooleanTypeLabels, EmailProviderTypeLabels, Position } from 'constants/common';

const DataTableColumnsConfigs = (t) => {
    return {
        columns: [
            {
                text: l.ProviderId,
                dataKey: 'EmailProviderId',
                sortable: true,
                colRenderer: (id) => (
                    <CopyToClipboard withWrapper={true}>
                        <TittleLink isClickable={false} name={id} />
                    </CopyToClipboard>
                ),
            },
            {
                text: l.Name,
                dataKey: 'Name',
                sortable: true,
                colRenderer: (name) => (
                    <CopyToClipboard position={Position.Left} withWrapper={true}>
                        <TittleLink isClickable={false} name={name} />
                    </CopyToClipboard>
                ),
            },
            {
                text: l.FromAddress,
                dataKey: 'FromAddress',
                sortable: true,
                colRenderer: (address) => (
                    <CopyToClipboard position={Position.Left} withWrapper={true}>
                        <TittleLink isClickable={false} name={address} />
                    </CopyToClipboard>
                ),
            },
            {
                text: l.Host,
                dataKey: 'Host',
                sortable: true,
                colRenderer: (host) => (
                    <CopyToClipboard position={Position.Left} withWrapper={true}>
                        <TittleLink isClickable={false} name={host} />
                    </CopyToClipboard>
                ),
            },
            {
                text: l.Port,
                dataKey: 'Port',
                sortable: true,
            },
            {
                text: t(l.Type),
                dataKey: 'Type',
                sortable: true,
                colRenderer: (type) => <>{EmailProviderTypeLabels[type]}</>,
            },
            {
                text: l.UserName,
                dataKey: 'UserName',
                sortable: true,
                colRenderer: (userName) => <TittleLink isClickable={false} name={userName} />,
            },
            {
                text: l.Parallelism,
                dataKey: 'MaxDegreeOfParallelism',
                sortable: true,
            },
            {
                text: l.DelayTimeout,
                dataKey: 'DelayTimout',
                sortable: true,
            },
            {
                text: l.Partners,
                dataKey: 'Partners',
                sortable: false,
                colRenderer: (partners) => <AdminProviderPartnersInfo partners={partners} />,
            },
            {
                text: l.IsDefault,
                dataKey: 'IsDefault',
                sortable: true,
                colRenderer: (IsDefault) => <>{BooleanTypeLabels[IsDefault]}</>,
            },
            {
                text: l.SSL,
                dataKey: 'EnableSsl',
                sortable: true,
                colRenderer: (isEnable) => <>{BooleanTypeLabels[isEnable]}</>,
            },
            {
                text: l.NotInjectUnsubscribeLink,
                dataKey: 'NotInjectUnsubscribeLink',
                sortable: false,
                colRenderer: (isEnable) => <>{BooleanTypeLabels[isEnable ?? false]}</>,
            },
            {
                text: l.Description,
                dataKey: 'Description',
                sortable: true,
                colRenderer: (description) => <TittleLink isClickable={false} name={description ?? l.NA} />,
            },
            {
                text: l.PartnerEmail,
                dataKey: 'PartnerEmail',
                sortable: true,
                colRenderer: (partnerEmail) => <TittleLink isClickable={false} name={partnerEmail ?? l.NA} />,
            },
        ],
    };
};

export { DataTableColumnsConfigs };
